<form class="control-container" (ngSubmit)="onSearch()" autocomplete="off" action="">
    <input class="control control-icon" type="text" name="search" [placeholder]="placeholder" [(ngModel)]="search" (input)="onKeyPress()">
    <i *ngIf="!search" class="fa-solid fa-magnifying-glass icon mt-[1.2px]"></i>
    <i *ngIf="search" class="fa-solid fa-circle-xmark icon cursor-pointer mt-[1.2px]" (click)="onClearField()"></i>
</form>